module.exports = __webpack_public_path__ + "static/media/vacctrack-outline.3a2a5747.png";